<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: 'large',
    validator: (value) => ['small', 'large'].includes(value)
  },
  side: {
    type: String,
    default: 'right',
    validator: (value) => ['left', 'right', 'top', 'bottom'].includes(value)
  }
});

const contentClasses = computed(() =>
  [props.size, props.side].map((item) => `tooltip-content-container--${item}`)
);
</script>

<template>
  <div class="tooltip-content-container" :class="contentClasses">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.tooltip-content-container {
  white-space: normal;
  background: var(--color-bg-level-01);
  border: var(--border-stroke-default) solid var(--color-border-strong-emphasis);
  padding: var(--spacing-small) var(--spacing-medium);
  border-radius: var(--spacing-xsmall);
  color: var(--color-text-strong-on-dark);
  max-width: 400px;

  &--small {
    padding: var(--spacing-xsmall) var(--spacing-small);
  }

  &--left,
  &--right {
    margin: 0 var(--spacing-small);
  }
  &--top,
  &--bottom {
    margin: var(--spacing-small) 0;
  }
}
</style>
